module.exports = __webpack_public_path__ + "img/sal-12.0982f648.jpg";